const fieldNames = {
  HEAD_CODE: 'headCode',
  HEADER_CODE: 'headerCode',
  FOOTER_CODE: 'footerCode',
};

export default fieldNames;
